"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlagOption = exports.OptionTypesEnum = exports.FlagOptionsEnum = void 0;
const typeorm_1 = require("typeorm/browser");
const data_ui_1 = require("../../data-ui");
const layouts_1 = require("../../data-ui/layouts");
const contact_profile_enum_1 = require("../contact-profile-enum");
const question_option_1 = require("./question-option");
var FlagOptionsEnum;
(function (FlagOptionsEnum) {
    FlagOptionsEnum["AUTO_CREATE_JOB"] = "Auto Create Job";
})(FlagOptionsEnum = exports.FlagOptionsEnum || (exports.FlagOptionsEnum = {}));
var OptionTypesEnum;
(function (OptionTypesEnum) {
    OptionTypesEnum["BOOLEAN"] = "boolean";
    OptionTypesEnum["STRING"] = "string";
    OptionTypesEnum["DOUBLE"] = "double";
    OptionTypesEnum["INTEGER"] = "integer";
    OptionTypesEnum["DATE"] = "date";
})(OptionTypesEnum = exports.OptionTypesEnum || (exports.OptionTypesEnum = {}));
let FlagOption = class FlagOption {
};
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.Override({ generated: true }),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
        name: 'id',
    }),
    __metadata("design:type", Number)
], FlagOption.prototype, "id", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)('character varying', {
        nullable: false,
        length: 255,
    }),
    __metadata("design:type", String)
], FlagOption.prototype, "name", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ label: 'Flag Option' }),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: FlagOptionsEnum,
        nullable: false,
    }),
    __metadata("design:type", String)
], FlagOption.prototype, "option", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ label: 'Option Type' }),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: OptionTypesEnum,
        nullable: false,
    }),
    __metadata("design:type", String)
], FlagOption.prototype, "type", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], FlagOption.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], FlagOption.prototype, "updatedAt", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToMany)(() => question_option_1.QuestionOption, (questionOption) => questionOption.flagOption),
    __metadata("design:type", Array)
], FlagOption.prototype, "questionOptions", void 0);
FlagOption = __decorate([
    data_ui_1.DataUi.Permissions({
        read: [contact_profile_enum_1.ContactProfileEnum.PRODUCT, contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER],
        write: [contact_profile_enum_1.ContactProfileEnum.PRODUCT, contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER],
    }),
    data_ui_1.DataUi.Name({
        name: 'FlagOption',
        nameProperties: ['name', 'type'],
    }),
    data_ui_1.DataUi.DefaultLayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Unique)(['name', 'option', 'type']),
    (0, typeorm_1.Entity)('flag_option', { schema: 'order_intake_forms' })
], FlagOption);
exports.FlagOption = FlagOption;
//# sourceMappingURL=flag-option.js.map